export { default as Collapsible } from './Collapsible';
export { default as CollapsibleBase } from './CollapsibleBase';
export { default as CollapsibleHeader } from './CollapsibleHeader';
export type { CollapsibleProps } from './Collapsible';
